export const ICON_MARGIN_LEFT = 24

export const DEEP_BLUE_GRADIENT_BUTTON_WIDTH = 200
